<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getDetails,
  exportB2bBill,
  switchRate,
  exportB2bBillNew,
	remove,
} from "@/api/double/bill";
import { exportB2bBillFormatter } from "@/api/double/bill_hq";
import { getChargingType } from "@/api/double/list";

import numFun from "@/utils/numFun";

import cTable from "@/base/common/index";
import expandRow from "./expand";

export default {
  components: {
    cTable,
    expandRow,
  },
  props: {
    currency: {
      type: Array,
    },
    row: {
      type: Object,
    },
  },
  data() {
    return {
      expandRefs: {},
      config: {
        rate: true,
        slot: "div",
        rows: this.row,
        rowId: "id",
        expandConfig: {
          expandAll: true,
          // accordion: true,
          reserve: true,
        },
      },
      totalAmount: [],
      methods: {
        list: (p) => {
          p.id = this.config.rows.id;
          return getDetails(p);
        },
        switchRate,
        exportB2bBill,
        exportB2bBillNew,
        getChargingType,
        exportB2bBillFormatter,
				remove,
        afterHandleList() {
          this.getTable().setAllRowExpand(true);
        },
        beforeHandleList: ({ data }) => {
          this.totalAmount = [];
          this.totalAmount.push(
            {
              text: this.$t("total"),
              replace_currency: "CNY",
              total_amount: data.total_cny,
            },
            {
              text: this.$t("total"),
              replace_currency: "USD",
              total_amount: data.total_usd,
            },
            {
              text: this.$t("total"),
              replace_currency: "SAR",
              total_amount: data.total_sar,
            },
            {
              text: this.$t("total"),
              replace_currency: "AED",
              total_amount: data.total_aed,
            },
            {
              text: this.$t("total"),
              replace_currency: "QAR",
              total_amount: data.total_qar,
            },
            {
              text: this.$t("total"),
              replace_currency: "KWD",
              total_amount: data.total_kwd,
            }
          );
        },
      },
      modals: {
        rate: {
          methods: {
            ok({ row, close }) {
              let list = Object.values(this.$page.expandCheckList).reduce(
                (a, b) => {
                  a.push(...b);
                  return a;
                }
              );
              let finance_id = list.map((t) => t.id);
              this.$page
                .handleRequestMethods("switchRate", {
                  id: this.$page.config.rows.id,
                  finance_id,
                  ...row,
                })
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              to_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              rate: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ to_currency: 24 }],
          fields: [
            {
              name: this.$t("toCurrency"),
              key: "to_currency",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("toCurrency"),
              options: [],
              config: {
                label: "value",
                value: "key",
              },
              methods: {
                list: ({ field, value }) => {
                  field.options = this.currency || [];
                },
                "on-change"({ field, value }) {
                  field.options.forEach((t) => {
                    if (t.key === value) this.$form.to_currency = t.value;
                  });
                },
              },
            },
          ],
        },
        add: {
          methods: {
            ok({ row, close }) {
              this.$page.handleRequestMethods("addB2bBill", row).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              client_ids: [
                {
                  required: true,
                  type: "number",
                  message: this.$t("select") + this.$t("clientName"),
                  trigger: "change",
                },
              ],
              name: [
                {
                  required: true,
                  message: this.$t("enter") + this.$t("codNAme"),
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ client_ids: 24 }, { name: 24 }],
          fields: [
            {
              name: () => this.$t("clientName"),
              key: "client_ids",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("order_number"),
              options: [],
              config: { label: "account", value: "id" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getB2bBillUSer")
                  ).payload;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
            },
          ],
        },
        update: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("updateB2bBill", row)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ name: 24 }, { remarks: 24 }],
          fields: [
            {
              name: () => this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                rows: 5,
                type: "textarea",
              },
            },
          ],
        },
        writeOff: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = row;
              delete data.bill_order;
              data.airway_number = this.selectAll.map(
                (item) => item.airway_number
              );
              this.$page
                .handleRequestMethods("b2bWriteOff", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
            checkTable({ row }) {
              let amount = 0;
              row.map((item) => {
                amount += parseFloat(item.amount);
                return;
              });
              this.$refs["form"].formData.check_amount = amount;
              this.$forceUpdate();
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              contract_header: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number",
                },
              ],
              check_amount: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              check_amount_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              payment_bank: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "number",
                  trigger: "change",
                },
              ],
              payment_time: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "date",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { contract_header: 24 },
            { payment_bank: 24 },
            { payment_time: 24 },
            { check_amount: 24 },
            { check_amount_currency: 24 },
            { transaction_id: 24 },
            // { search_cnbnum: 24 }
          ],
          fields: [
            {
              name: () => this.$t("contract_title"),
              key: "contract_header",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("contract_title"),
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods(
                      "getB2bContractHeader"
                    )
                  ).payload;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("bank"),
              key: "payment_bank",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("bank"),
              options: [],
              config: {
                label({ row }) {
                  return row.account_type + "(" + row.bank_code + ")";
                },
                value: "id",
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getBank")
                  ).payload;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("paid_time"),
              key: "payment_time",
              component: "DatePicker",
              placeholder: () => this.$t("select") + this.$t("paid_time"),
              bind: {
                type: "datetime",
                format: "yyyy-MM-dd HH:mm:ss",
              },
            },
            {
              name: () => this.$t("check_amount"),
              key: "check_amount",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.0001,
                style: "width:100%",
              },
              default: 0,
            },
            {
              name: () => this.$t("check_amount_currency"),
              key: "check_amount_currency",
              component: "Select",
              placeholder: () =>
                this.$t("select") + this.$t("check_amount_currency"),
              options: [
                { label: this.$t("to_rmb"), value: "CNY" },
                { label: this.$t("to_usd"), value: "USD" },
              ],
            },
            {
              name: () => this.$t("transaction_id"),
              key: "transaction_id",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("transaction_id"),
            },
            // {
            //   name: () => this.$t("order_number"),
            //   key: "search_cnbnum",
            //   component: "Input",
            //   placeholder: () =>
            //     this.$t("enter") + this.$t("order_number") + this.$t("search"),
            //   methods: {
            //     "on-search"({ formData }) {
            //       let that = this.$page.getModal("writeOff");
            //       let arr = that.list;
            //       if (formData.search_cnbnum == "") {
            //         that.list = that.billOrder;
            //         return;
            //       }
            //       that.list = arr.filter(
            //         item =>
            //           item.search_cnbnum
            //             .toLowerCase()
            //             .indexOf(formData.search_cnbnum.toLowerCase()) !== -1
            //       );
            //     }
            //   },
            //   bind: {
            //     suffix: "ios-search",
            //     search: true
            //   }
            // }
          ],
          table: {
            config: {
              height: 300,
            },
            fields: [
              {
                type: "checkbox",
                width: 60,
                fixed: "left",
              },
              {
                name: () => this.$t("order_number"),
                key: "airway_number",
                minWidth: 100,
              },
              {
                name: () => this.$t("reChAmount"),
                key: "amount",
                align: "left",
                minWidth: 100,
                // methods: {
                //   render() {
                //     return options.find(
                //       item =>
                //         item.value ==
                //         this.getModal("add").$refs["form"].formData.period
                //     ).label;
                //   }
                // }
              },
              // {
              //   name: () => this.$t("salesman"),
              //   key: "salesman_account",
              //   align: "left",
              //   minWidth: 100
              // }
            ],
          },
        },
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 1500,
            },
          },
          footer: { show: () => false },
        },
      },
      footer: {
        show: () => true,
        render: (h) => {
          return h(
            "div",
            {
              class: "footer-content",
            },
            this.totalAmount.map((item) => {
              return h(
                "div",
                {
                  class: "footer-content-item",
                },
                [
                  h("span", { class: "span-head" }, item.text),
                  h(
                    "span",
                    { class: "span-head" },
                    item.replace_currency + ":"
                  ),
                  h(
                    "span",
                    {
                      class: "span-title",
                    },
                    numFun.formatNum(parseFloat(item.total_amount))
                  ),
                ]
              );
            })
          );
        },
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 1, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            // {
            //   name: this.$t("export"),
            //   type: "export",
            //   fnName: "export",
            //
            //   bind: {
            //     icon: "md-arrow-down",
            //     type: "primary",
            //   },
            // },
            // {
            //   name: this.$t("export") + "2",
            //   type: "exportNew",
            //   fnName: "exportNew",
            //
            //   bind: {
            //     icon: "md-arrow-down",
            //     type: "primary",
            //   },
            // },
            {
              name: this.$t("export"),
              type: "exportFormatter",
              fnName: "exportFormatter",
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: this.$t("rate"),
              type: "rate",
              fnName: "rate",
              disabled() {
                return this.config.rate;
              },
              bind: {
                type: "warning",
              },
            },
						{
						  name: this.$t("delete"),
						  type: "delete",
						  fnName: "delete",
						  disabled() {
						    return !this.selectAll.length;
						  },
						  bind: {
						    type: "warning",
						  },
						},
          ],
          methods: {
						delete(){
							let airway_numbers = this.selectAll.map(item=>item.airway_number)
							this.$Modal.confirm({
							  title: this.$t("whether") + this.$t("DelDetail"),
							  width: 300,
							  content: this.$t("titleModal"),
							  onOk: () => {
							    this.handleRequestMethods("remove", {id:this.config.rows.id,airway_numbers}).then(
							      (res) => {
							        this.$Message["success"]({
							          background: true,
							          content: res.msg,
							        });
							        this.getList();
							      }
							    );
							  },
							});
						},
            // 导出
            export() {
              this.handleRequestMethods(
                "exportB2bBill",
                this.config.rows.id,
                true,
                true
              ).then((res) => {
                window.open(this.$globalUrl + res.payload.src);
              });
            },
            exportNew() {
              this.handleRequestMethods(
                "exportB2bBillNew",
                this.config.rows.id,
                true,
                true
              ).then((res) => {
                window.open(this.$globalUrl + res.payload.src);
              });
            },
            exportFormatter() {
              this.handleRequestMethods(
                "exportB2bBillFormatter",
                this.config.rows.id,
                true,
                false
              ).then((res) => {
                window.open(res.payload.src);
              });
            },
            rate() {
              if (this.expandCheckList) {
                this.modals.rate.grid.splice(1);
                this.modals.rate.fields.splice(1);
                let list = Object.values(this.expandCheckList).reduce(
                  (a, b) => {
                    a.push(...b);
                    return a;
                  }
                );
                let currency = Array.from(new Set(list.map((t) => t.currency)));
                currency.forEach((t) => {
                  let key = "to_rate";
                  let name = "to_" + t.toLocaleLowerCase();
                  if (t !== "USD") {
                    key += "_" + t.toLocaleLowerCase();
                  }
                  this.modals.rate.grid.push({ [key]: 24 });
                  this.modals.rate.fields.push({
                    name() {
                      return (
                        this.$t(name) +
                        this.$t("turn") +
                        (this.$form.to_currency || "") +
                        this.$t("rate")
                      );
                    },
                    key,
                    component: "InputNumber",
                    bind: {
                      min: 0,
                      step: 0.0001,
                      style: "width:100%",
                    },
                    default: 0,
                  });
                  this.getModal("rate").open();
                });
              }
            },
          },
        },
      },
      fields: [
				{
				  type: "checkbox",
				  width: 60,
				},
        {
          width: 35,
          type: "expand",
          showOverflow: false,
          expandRender: (h, p) => {
            let el = h(expandRow, {
              props: {
                row: p.row,
              },
            });
            this.expandRefs[p.row.id] = el;
            return el;
          },
        },
        {
          name: () => this.$t("clientName"),
          key: "account",
          minWidth: 100,
          align: "left",
        },
        {
          name: () => this.$t("shipper_company_cn"),
          key: "shipper_company",
          minWidth: 100,
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_number",
          minWidth: 130,
        },
        {
          name: () => this.$t("method_name"),
          key: "transport_code_txt",
          minWidth: 100,
        },
        {
          name: () => this.$t("city_t"),
          key: "city",
          minWidth: 150,
          align: "left",
        },
        {
          name: () => this.$t("tracker_code"),
          key: "status",
          minWidth: 100,
        },
        {
          name: () => this.$t("status_time"),
          key: "status_time",
          minWidth: 170,
        },
        {
          name: () => this.$t("total_amount"),
          children: [
            {
              name: () => "CNY",
              key: "total_amount_cny",
              minWidth: 100,
            },
            {
              name: () => "USD",
              key: "total_amount_usd",
              minWidth: 100,
            },
            {
              name: () => "SAR",
              key: "total_amount_sar",
              minWidth: 100,
            },
            {
              name: () => "AED",
              key: "total_amount_aed",
              minWidth: 100,
            },
            {
              name: () => "QAR",
              key: "total_amount_qar",
              minWidth: 100,
            },
            {
              name: () => "KWD",
              key: "total_amount_kwd",
              minWidth: 100,
            },
          ],
        },
      ],
    };
  },
};
</script>
